import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/compliance-audit/overview/')({
    beforeLoad: ({ params }): ShareableRouteContext => {
        throw redirect({ to: '/console/$orgId/tools/compliance-audit/overview/search', params, replace: true });
    },
});
